import type { UTMParams } from './tipos'

const UTM_STORAGE_KEY = 'biomo_utm_params'
const UTM_EXPIRY_KEY = 'biomo_utm_expiry'

// Expiração de 30 dias (padrão Google Ads)
const UTM_EXPIRY_DAYS = 30

const UTM_VAZIO: UTMParams = {
  source: null,
  medium: null,
  campaign: null,
  content: null,
  term: null,
  id: null,
  gclid: null,
}

/**
 * Salva UTMs no localStorage com expiração de 30 dias
 */
function salvarUTMs(utmParams: UTMParams): void {
  if (typeof window === 'undefined') return

  try {
    const expiryTime = Date.now() + (UTM_EXPIRY_DAYS * 24 * 60 * 60 * 1000)
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmParams))
    localStorage.setItem(UTM_EXPIRY_KEY, String(expiryTime))
  } catch {
    // localStorage indisponível
  }
}

/**
 * Extrai e persiste UTMs da URL
 * Prioridade: URL > localStorage (com expiração de 30 dias)
 */
export function getUTMParams(): UTMParams {
  if (typeof window === 'undefined') return UTM_VAZIO

  // 1. Extrair da URL atual
  const params = new URLSearchParams(window.location.search)
  const urlUtms: UTMParams = {
    source: params.get('utm_source'),
    medium: params.get('utm_medium'),
    campaign: params.get('utm_campaign'),
    content: params.get('utm_content'),
    term: params.get('utm_term'),
    id: params.get('utm_id'),
    gclid: params.get('gclid'),
  }

  // 2. Se a URL tem UTMs ou gclid, salvar e usar
  if (urlUtms.source || urlUtms.gclid) {
    salvarUTMs(urlUtms)
    return urlUtms
  }

  // 3. Tentar localStorage (com expiração)
  try {
    const saved = localStorage.getItem(UTM_STORAGE_KEY)
    const expiry = localStorage.getItem(UTM_EXPIRY_KEY)

    if (saved && expiry && Date.now() < parseInt(expiry)) {
      return JSON.parse(saved) as UTMParams
    }

    // Expirado, limpar
    if (saved) {
      localStorage.removeItem(UTM_STORAGE_KEY)
      localStorage.removeItem(UTM_EXPIRY_KEY)
    }
  } catch {
    // localStorage indisponível
  }

  return UTM_VAZIO
}
